<template>
  <div id="site-policy">
    <div class="title"></div>
    <div class="area">
      <div class="policy">
        <h2>当サイトの利用について</h2>
        <p>
          このWebサイト「おかずかん」（以下「当サイト」と記）は、株式会社コスモジャパン（以下「当社」と記）が所有・運営しております。
          <br />当サイトのご利用にあたっては、以下のサイトポリシーをご理解・ご了承の上でご利用くださいませ。
        </p>
      </div>
      <div class="policy">
        <h2>当サイトの著作権・商標について</h2>
        <p>
          当サイトに掲載されているコンテンツ（文字、写真、イラスト等）に関する著作権は、当社に帰属します。
          <br />私的使用目的等、法律で認められる場合を除いては、当サイトのコンテンツを許可なく複製・転用・販売・公開等をすることを禁じます。
          <br />当サイト上に掲載される個々の商標・ロゴマーク・商号に関する権利は、当社に帰属します。
          <br />法律で認められる範囲を除き、許可なく使用することはできません。
          <br />
        </p>
      </div>
      <div class="policy">
        <h2>当サイトの免責事項</h2>
        <p>
          当サイトに掲載された情報に基づいて為された判断を原因としてトラブル・損失・損害が発生した場合、いかなる事があっても、当社は一切責任を負いません。
          <br />当サイトに掲載されたすべての情報、または一部の情報は、当社判断において予告なく変更・中断することがあります。また、当サイトの運営・公開は予告なく中止することがあります。
          <br />当サイトからの情報をご利用になられた、またご利用になれなかったことにより生じたいかなるトラブル・損失・損害についても当社は一切責任を負いません。
          <br />
        </p>
      </div>
      <div class="policy">
        <h2>プライバシーポリシー</h2>
        <p>
          当社は、個人情報の重要性を鑑み、プライバシーポリシーを制定し、実行することにより個人情報保護に努めております。
          <br />準拠法及び管轄裁判所当サイトの利用について紛争が生じた場合には、東京地方裁判所を第一審の専属的合意管轄とします。
          <br />当サイトの利用について紛争が生じた場合には、別段の定めのない限り、準拠法は日本法とします。
          <br />
        </p>
      </div>
      <div class="policy">
        <h2>当サイトへのリンクについて</h2>
        <p>
          当サイトからのリンク・バナーによって他サイトへ移動できる場合があります。移動された先の他サイトは当社が運営するものではありません。したがって、その内容等に対して生じたいかなるトラブル・損失・損害についても当社は責任を負いかねますのでご了承ください。
          <br />当サイトへのリンク設定は、原則として自由です。ただし、以下に該当するWebサイトからのリンクはお断りいたします。
          <br />・当社または役員・社員、及びサービス・製品を誹謗・中傷するWebサイトからのリンク
          <br />・違法である情報を含むWebサイトからのリンク <br />・公序良俗に反するWebサイトからのリンク
          <br />・営利を目的とするWebサイトからのリンク （当社が許可をしたものは除く）
          <br />・独自のフレーム内に当サイトを取り込んだ形など、当サイトの情報であることが不明確となるWebサイトからのリンク
          <br />
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  // =============================================
  //  name
  // =============================================
  name: 'SitePolicy',
  mounted() {
    this.$emit('hideHeader');
  },
};
</script>

<style>
#site-policy {
  font-family: Arial, Helvetica, sans-serif;
  font-size: 0.8em;
}

.title {
  width: 200px;
  margin: 10px;
  background-color: #ababab;
}

.area {
  margin: 3%;
  padding: 3%;
  text-align: left;
  background-color: #ffffff;
  border-radius: 5px;
}

.policy {
  margin-bottom: 20px;
}

.h2 {
  font-size: 0.8em;
  font-weight: bold;
  margin: 15px 0;
}

.h3 {
  font-size: 0.6em;
  margin: 15px 0;
}

.p {
  font-size: 0.6em;
}
</style>
